var map = {
	"./Bahnhof_02.jpg": 3462,
	"./Baustelle_02.jpg": 1143,
	"./Business_02.jpg": 8640,
	"./Dom_02.jpg": 5846,
	"./Einkaufszentrum_02.jpg": 4255,
	"./Energie_02.jpg": 2837,
	"./Fabrik_02.jpg": 2415,
	"./Flughafen_03.jpg": 4669,
	"./Forschung_02.jpg": 2363,
	"./Fussball_02.jpg": 9900,
	"./Hafen_02.jpg": 4474,
	"./Martha Herford_02.jpg": 5667,
	"./MultiKulti_02.jpg": 534,
	"./Natur_03.jpg": 4043,
	"./StartUp_02.jpg": 6503,
	"./Uni_02.jpg": 6988,
	"./Uni_03.jpg": 4777
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6971;